import { Checkbox, FormControlLabel, Typography } from '@mui/material';

interface NoTransactionsCheckboxProps {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function NoTransactionsCheckbox({ checked, onChange }: Readonly<NoTransactionsCheckboxProps>) {
    return (
        <FormControlLabel
            control={<Checkbox checked={checked} onChange={onChange} size="small" color="secondary" />}
            label={
                <Typography variant="body2" fontWeight={500} color="text.primary">
                    I don&apos;t have any business transactions to add
                </Typography>
            }
            sx={{ alignItems: 'center' }}
        />
    );
}
